import React, { useEffect, useState } from "react";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import Cookies from "js-cookie";
import Nav from "../ui/Nav";
import Space from "../ui/Space";
import EmployeeLogin from "./EmployeeLogin";
import { bm_date, showConfirm } from "../utils/Utils";
import WorkstationInput from "./Prompt";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import Prompt from "./Prompt";
export default function Workstation(props) {

    const { controller = "", signal = {}, route = "", callback = () => { } } = props;

    const [workstation, setWorkstation] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState({});
    const [align, setAlign] = useState("start");
    const row_key = "number";

    const last_workstation = Cookies.get("last_workstation") || 0;

    const onConfirm = (_selected = selected) => {

        pubCall("work_station.set", { station: _selected?.number }, (_s, _r) => {
            if (_s) {
                Cookies.set("last_workstation", _selected?.number);
                signal.value = { ...signal.value, "session": _r }
                callback(_r);
            } else {
                showError(_r)
            }
        })

    }

    const login = (_selected = selected) => {

        if (_selected?.active) {
            showConfirm({
                controller : controller,
                route,
                description: (
                    <div style={{ textAlign: "center", "width": "330px" }}>
                        Selecting this station will log you in and force the current user out of their session.
                        <div className="shim" /><div>Are you sure?</div><div className="shim" />
                    </div>
                ),
                title: "Warning",
                callback: confirmed => {
                    if (confirmed) {
                        onConfirm(_selected)
                    }
                }
            });
        } else {
            onConfirm(_selected);
        }
    }

    const actions = [
        { key: KBD.ENTER, action: () => { login() } },
        { key: KBD.N, action: () => { createNew() } },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ENTER]);
        return cleanup;
    }, [actions])


    const fetchWorkstations = () => {
        setLoading(true)
        pubCall("work_station.getAll", { initial: true }, (_s, _r) => {
            setLoading(false);
            if (_s) {
                setData(_r);
                let _f = _r.find(item => item.number == last_workstation);
                if (_f) {
                    setSelected(_f);
                } else {
                    setSelected(_r?.[0] || {})
                }

            } else {
                showError(_r);
            }
        })
    }

    useEffect(fetchWorkstations, []);


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const columns = [
        { key: "active", title: <>Live</>, align: "center", width: 35, render: (e) => { return (e) ? <span style={{ "color": "var(--text-green)" }}>•</span> : "" } },
        { key: "number", title: <>#</>, align: "center", width: 35 },
        {
            key: "last_active", title: <>Last Active</>, align: "left", width: 90, render: (e) => {
                return (e) ? bm_date(e) : "";
            }
        },
        { key: "name", title: <>Name</>, align: "left", width: 1, grow: true },
    ];

    const nav = [
        { text: "Enter", key: KBD.ENTER },
        { text: "New", key: KBD.N },
    ]

    

    const createNew = () => {

        window.bm_state.value = ROUTES.HELPERS.PROMPT;
        createModal({
            component: <Prompt controller={controller} description="Enter your workstation ID" inputProps={{ style : {"textAlign" : "center"}, uppercase : true, maxLength : 2, width : 40}}  signal={signal} route={ROUTES.HELPERS.PROMPT} />, closable: true,  title: "Workstation", callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    if (isNaN(parseInt(e))) {
                        showError({ error: "Not a valid station number" })
                    } else {
                        let _f = data.find(item => item.number == e);
                        if (_f) {
                            login(_f)
                        } else {
                            login({ active: false, number: parseInt(e) })
                        }
                    }
                }
            }
        })
    }

    return (
        <>
            <div style={{ "width": "454px" }}>
                <div className="shim" /><div className="shim" />
                <div style={{ "textAlign": "center", "width": "154px" }}>
                    <VirtualTable
                        controller={controller}
                        onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                        next={next}
                        scrollbar={true}
                        prev={prev}
                        onRowDoubleClick={(e) => login(e)}
                        align={align}
                        row_key={row_key}
                        current={selected}
                        data={data}
                        columns={columns}
                        width={450}
                        loading={false}
                        offset={608}
                        route={route}
                    />
                </div>
            </div>
            <div className="shim" />
            <div style={{ 'height': "20px" }}>
                <Space style={{ "padding": "0px 0px" }}>
                    <Nav nav={nav} />
                </Space>
            </div>

        </>
    )
}